import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import SearchBar, { SearchBarProps } from '../../Search/Bar';

const SearchTeamSearchBar: React.FC<SearchBarProps> = (props) => {
  const { t } = useTranslation();

  const classNames = c('SearchAllContent__SearchBar');

  return (
    <SearchBar
      {...props}
      className={classNames}
      placeholder={t('components.search_team.search_bar.placeholder')}
      buttonText={t('buttons.search')}
    />
  );
};

export default SearchTeamSearchBar;
